import { render, staticRenderFns } from "./EmpMg.vue?vue&type=template&id=b29b8aae&scoped=true"
import script from "./EmpMg.vue?vue&type=script&lang=js"
export * from "./EmpMg.vue?vue&type=script&lang=js"
import style0 from "./EmpMg.vue?vue&type=style&index=0&id=b29b8aae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29b8aae",
  null
  
)

export default component.exports